import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 w-full" }

import { computed } from "vue";

import { useSessionStore } from "@/store/sessionStore";
import { useAccountStore } from "@/store/accountStore";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import ProfileCard from "@/modules/Settings/components/ProfileCard.vue";
import { greeting } from "@/helpers/greetinghelper";
import CompanyCard from "@/modules/Settings/components/CompanyCard.vue";
import FtpSettingsCard from "@/modules/Settings/components/FtpSettingsCard.vue";
import MembersCard from "@/modules/Settings/components/MembersCard.vue";
import FavoritesCard from "../components/FavoritesCard.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsView',
  setup(__props) {

const accountStore = useAccountStore();
const sessionStore = useSessionStore();

const isOwnerOfSelectedCareProviderGroup = computed(
  () =>
    sessionStore.session?.user.id ==
    sessionStore.selectedCareProviderGroup?.owner
);

return (_ctx: any,_cache: any) => {
  const _component_VersionDisplay = _resolveComponent("VersionDisplay")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(UmanaHeadline, {
      h: "h1",
      class: "mb-xs"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(greeting)()) + ", " + _toDisplayString(_unref(accountStore).firstName ?? "") + " " + _toDisplayString(_unref(accountStore).lastName ?? ""), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ProfileCard),
      _createVNode(CompanyCard, {
        "is-owner-of-selected-care-provider-group": 
          isOwnerOfSelectedCareProviderGroup.value
        
      }, null, 8, ["is-owner-of-selected-care-provider-group"]),
      _createVNode(FtpSettingsCard, {
        "is-owner-of-selected-care-provider-group": 
          isOwnerOfSelectedCareProviderGroup.value
        
      }, null, 8, ["is-owner-of-selected-care-provider-group"]),
      _createVNode(MembersCard, {
        "is-owner-of-selected-care-provider-group": 
          isOwnerOfSelectedCareProviderGroup.value
        
      }, null, 8, ["is-owner-of-selected-care-provider-group"]),
      _createVNode(FavoritesCard)
    ]),
    _createVNode(_component_VersionDisplay)
  ]))
}
}

})